export const SET_ACTIVE_ACCOUNT_FORM_PANEL = "SET_ACTIVE_ACCOUNT_FORM_PANEL";
